import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { useActiveSubscriptions } from "@/features/billing/hooks";
import { NewMedicationRequestButton } from "@/features/my-meds/components";
import {
  useAvailableRefillRequests,
  useCurrentMedicationRequests,
} from "@/features/my-meds/hooks";
import { PRICE_TYPE } from "@/shared/domains";
import { Button, Header } from "@/shared/ui";

export const MyMedsHeader = () => {
  const { data: availableRefillRequests } = useAvailableRefillRequests();
  const { data: currentMedicationRequests } = useCurrentMedicationRequests();
  const { data: activeSubscriptions } = useActiveSubscriptions();

  const hasMedicationRequests = Boolean(currentMedicationRequests?.length);
  const hasAvailableRefillRequests = Boolean(availableRefillRequests?.length);
  const hasOnlyOneTimeProducts = Boolean(
    activeSubscriptions?.every(
      (subscription) =>
        subscription.currentProduct.price.type === PRICE_TYPE.ONE_TIME,
    ),
  );

  const showGoToShopButton =
    !hasAvailableRefillRequests && hasOnlyOneTimeProducts;
  const showNewMedicationButton = hasAvailableRefillRequests;
  const showActions = showGoToShopButton || showNewMedicationButton;

  return (
    <Header.Root>
      <Header.Content>
        <div className="flex items-center justify-between">
          <Header.Title>{t`My Meds`}</Header.Title>

          {hasMedicationRequests && showActions && (
            <Header.Actions className="hidden md:block">
              {showGoToShopButton ? (
                <Button size="lg" asChild>
                  <Link to={ROUTES.SHOP.OVERVIEW}>{t`Go to Shop`}</Link>
                </Button>
              ) : (
                <NewMedicationRequestButton />
              )}
            </Header.Actions>
          )}
        </div>
      </Header.Content>
    </Header.Root>
  );
};
